export default {"src":"/_next/static/media/404_cockenpot_paysage.8cbee0b3.svg","height":225,"width":423,"blurWidth":0,"blurHeight":0};